import { defineMessages } from 'react-intl';

export const inviteTeamStepMessages = defineMessages({
  title: {
    defaultMessage: 'Invite your team to try Heidi with you',
    id: 'URjzyjVKpe',
    description: 'Onboarding invite-team step heading',
  },
  subtitle: {
    defaultMessage: 'Easily share notes, documents and tasks.',
    id: 'N14GyUd/hq',
    description: 'Onboarding invite-team step subheading',
  },
  emailLabel: {
    defaultMessage: 'Invite by email',
    id: 'kQNKbqZqGM',
    description: 'Label for email invite field',
  },
  emailPlaceholder: {
    defaultMessage: 'Email address, separated by commas',
    id: 'MChLZU03ed',
    description: 'Placeholder for email invite chip field',
  },
  teamLabel: {
    defaultMessage: 'Invite your team',
    id: 'm5lhb7HOb4',
    description: 'Label for the free-text email invite field',
  },
  emailListPlaceholder: {
    defaultMessage: 'jane@company.com, john@company.com…',
    id: 'arK9/OAIwQ',
    description: 'Placeholder for the free-text email invite field',
  },
  sendInvites: {
    defaultMessage: 'Send invites',
    id: 'KRWIEh1Lj8',
    description: 'Primary action to save invite emails and continue onboarding',
  },
  skipForNow: {
    defaultMessage: 'Skip for now',
    id: 'r040QB7hid',
    description: 'Leaves the invite step without collecting invite emails',
  },
  skip: {
    defaultMessage: 'Skip',
    id: 'DyrM4WYLjk',
    description: 'Skip invite-team step without collecting invite emails',
  },
  continue: {
    defaultMessage: 'Continue',
    id: '9gNV1x5jND',
    description:
      'Primary action to save invite emails and continue onboarding (send deferred)',
  },
  invalidEmail: {
    defaultMessage: 'Please enter a valid email address',
    id: 'V8iAiLuLDM',
    description: 'Validation error for invalid emails on invite-team step',
  },
  invitesSentToast: {
    defaultMessage: 'Invites sent',
    id: 'LGHa5KgT3e',
    description: 'Toast after onboarding team invites send successfully',
  },
  invitesPartialToast: {
    defaultMessage: "Some invites couldn't be sent. Please try again later.",
    id: 'XcmNsHqd6D',
    description: 'Toast when some deferred onboarding invites failed',
  },
  teamNotReadyToast: {
    defaultMessage: 'Unable to send invites right now. Please try again.',
    id: 'TM8gJTM0Ku',
    description: 'Toast when Practice team is not ready for deferred invites',
  },
  cliniciansCount: {
    defaultMessage: '{count, plural, one {# clinician} other {# clinicians}}',
    id: 'H9vZPb2ury',
    description: 'Clinician count shown on invite-team preview panel',
  },
});
